var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarcelineHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29396",
    "data-name": "Group 29396",
    transform: "translate(-489 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(489 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29389",
    "data-name": "Group 29389",
    transform: "translate(507 348.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50153",
    "data-name": "Path 50153",
    d: "M22.418,15.386a40.635,40.635,0,0,1-.31,4.419c-.055.515-.1,1.008-.146,1.478a.46.46,0,0,1-.456.415H7.4a.456.456,0,0,1-.337-.15.451.451,0,0,1-.114-.351c.014-.141.018-.269.018-.388a28.549,28.549,0,0,0-.538-4.492A21.586,21.586,0,0,1,6,13c0-3.854,2.07-7.119,4.852-7.725A4.643,4.643,0,0,1,14.934,3a6.253,6.253,0,0,1,4.989,2.809A18.125,18.125,0,0,1,22.418,15.386Z",
    transform: "translate(-6 -3)",
    fill: "#151a43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50154",
    "data-name": "Path 50154",
    d: "M24.246,37.824H16.42C16.794,36.269,17.6,36,17.6,36h5.473S23.872,36.269,24.246,37.824Z",
    transform: "translate(-11.668 -20.95)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50155",
    "data-name": "Path 50155",
    d: "M24.209,41.824H16A7.867,7.867,0,0,1,16.192,40h7.826A7.867,7.867,0,0,1,24.209,41.824Z",
    transform: "translate(-11.44 -23.127)",
    fill: "#821616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50156",
    "data-name": "Path 50156",
    d: "M23.841,17.587c0,1.6-1.824,1.993-1.824,3.589,0,1.072.456,1.313,1.368,1.769l-2.736,1.824-2.736-1.824c.912-.456,1.368-.766,1.368-1.769,0-1.6-2.28-1.71-2.28-3.7,0-1.2,1.824-3.876,1.824-5.473l5.016,5.473Z",
    transform: "translate(-11.983 -7.896)",
    fill: "#bbdefb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50157",
    "data-name": "Path 50157",
    d: "M20.456,20a.456.456,0,1,0,.456.456A.456.456,0,0,0,20.456,20Zm2.736,0a.456.456,0,1,0,.456.456A.456.456,0,0,0,23.192,20Zm-.228,5.929a.228.228,0,1,0,.228.228A.228.228,0,0,0,22.964,25.929Zm0,.912a.228.228,0,1,0,.228.228A.228.228,0,0,0,22.964,26.841Zm-.229-5.233a2.028,2.028,0,0,1-1.823,0v.217h0v.912l.4-.6a1.008,1.008,0,0,0,1.028,0l.4.6v-.912h0Z",
    transform: "translate(-13.615 -12.247)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarcelineHighlighted);
export default __webpack_public_path__ + "static/media/marcelineHighlighted.f2901a56fa99e6d5c9f2fffe9b37cb53.svg";
export { ForwardRef as ReactComponent };